// Which platform a listing's video link belongs to. The portals embed
// YouTube, TikTok and Instagram (portal/lib/video-source.ts has the full
// parser); anything else is saved but never plays as a video.
// Mirror: mobile/utils/video-link.ts — keep both identical.

export type VideoLinkProvider = 'youtube' | 'tiktok' | 'instagram';

export function videoLinkProvider(raw: string | null | undefined): VideoLinkProvider | null {
  const value = (raw || '').trim();
  if (!value) return null;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  const host = url.hostname.replace(/^(www|m)\./, '');
  if (host === 'youtube.com' || host === 'youtu.be') return 'youtube';
  if (host === 'tiktok.com' || host === 'vt.tiktok.com' || host === 'vm.tiktok.com') return 'tiktok';
  if (host === 'instagram.com' && /\/(reel|reels|p|tv)\//.test(url.pathname)) return 'instagram';
  return null;
}

export const VIDEO_LINK_LABEL = 'Video (YouTube, TikTok o Instagram)';
export const VIDEO_LINK_PLACEHOLDER = 'https://youtube.com/…, tiktok.com/… o instagram.com/reel/…';
export const VIDEO_LINK_HELP = 'Se muestra en los portales. No se comparte en Intercambio.';
export const VIDEO_LINK_INVALID = 'Este enlace no es de YouTube, TikTok ni Instagram: se guardará, pero no se mostrará como video.';
